import { AccountFeatures } from '@lightspeed-invoicing/core-client/frontend';
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import $ from "jquery";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CustomSelect from '../../../src/common/search-filter/others/customSelect.component.jsx';
import { deletePricingTableGroup, patchPricingTableGroup } from '../../state/pricing/actions';
import ConfirmButton from "../button/confirmbutton.component.jsx";
import Icon from "../icon/icon.component.jsx";
import RichTextEditor from "../rich-text/editor.component.jsx";


class QuoteGroupNameModal extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            modalId: this.props.modalId || 'group-edit-modal',
            name: this.props.name,
            description: this.props.description,
            groupCalendarEventIds: this.props.groupCalendarEventIds || [],
            groupId: this.props.groupId ? this.props.groupId : '',
            endPoint: this.props.endPoint ? this.props.endPoint : '',
            documentType: this.props.documentType,
            documentId: this.props.documentId,
            availableCalendarEvents: this.props.availableCalendarEvents,
        }

        this.onCloseModal = this.onCloseModal.bind(this)
        this.handleRichTextChange = this.handleRichTextChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.remove = this.remove.bind(this)
        this.save = this.save.bind(this)
        this.buildEventOptions = this.buildEventOptions.bind(this)
        this.onEventsSelectionChange = this.onEventsSelectionChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            availableCalendarEvents: nextProps.availableCalendarEvents,
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    async remove(event) {
        event.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        await this.props.deletePricingTableGroup(this.props.groupId, this.props.documentId, this.props.type)
        this.props.onUpdateCallback()
        this.props.onCloseModal()
    }

    save(event) {
        $('#' + this.state.modalId).modal('hide')
        event.preventDefault()
        this.props.patchPricingTableGroup(this.props.groupId, this.props.documentId, this.props.type, {
            name: this.state.name,
            description: this.state.description,
            calendarEventIds: this.state.groupCalendarEventIds || [],
        }).then(_ => {
            this.props.onSaveChange(this.state.name, this.state.description, this.state.groupCalendarEventIds)
        })
    }

    handleFormChange(event) {
        this.setState({
            name: event.target.value
        });
    }

    handleRichTextChange(event) {
        this.setState({
            description: event
        });
    }

    onCloseModal() {
        $('#' + this.state.modalId).modal('hide')
        this.props.onCloseModal()
    }

    buildEventOptions(calendarEvents) {
        return calendarEvents.map(e => ({ value: e.id, label: e.attributes.title }))
    }

    onEventsSelectionChange(calendarEventIds) {
        this.setState({
            groupCalendarEventIds: calendarEventIds || []
        })
    }


    render() {
        const availableEvents = this.buildEventOptions(this.state.availableCalendarEvents)
        const groupEventOptions = availableEvents.filter(e => this.state.groupCalendarEventIds.includes(e.value))

        return (
            <form className="needs-validation" noValidate id="group-description-creation-modal">
                <div className={'modal'}
                    id={this.state.modalId}
                    role="dialog"
                    aria-labelledby={this.state.modalId + "Label"}
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className={'modal-dialog modal-signature'} role="document">
                        <div className={'modal-content'}>
                            <div className="modal-header">
                                <div className="modal-title h5" id={this.state.modalId + "Label"}>
                                    <FormattedMessage
                                        id="common.group_name.modal.title"
                                        defaultMessage="Edit Group"
                                    />
                                </div>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="form-group row mb-0">
                                        <label className="col-12 col-form-label custom-form-label pb-2">
                                            <FormattedMessage
                                                id="common.group.modal.name_label"
                                                defaultMessage="Name"
                                            />
                                        </label>
                                        <div className="col-12">
                                            <input
                                                name="name"
                                                value={this.state.name}
                                                onChange={this.handleFormChange}
                                                id="name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row mb-0">
                                        <label className="col-12 col-form-label custom-form-label pb-2">
                                            <FormattedMessage
                                                id="common.group.modal.description_label"
                                                defaultMessage="Description"
                                            />
                                        </label>
                                        <div className="col-12 text-dark">
                                            <RichTextEditor
                                                height={300}
                                                name="description"
                                                value={this.state.description}
                                                onChange={this.handleRichTextChange}
                                                id="description"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>


                                    {
                                        AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureScheduling) &&
                                        <div className="row">
                                            <label className="col-2 m-0 align-self-center">
                                                <FormattedMessage
                                                    id="common.group.modal.events_label"
                                                    defaultMessage="Events"
                                                />
                                            </label>
                                            <CustomSelect
                                                onChange={this.onEventsSelectionChange}
                                                className="col-10 pl-0"
                                                multi={true}
                                                options={availableEvents}
                                                value={groupEventOptions}
                                            />
                                        </div>
                                    }

                                </div>
                            </div>

                            <div className="modal-footer">
                                {this.props.isRemovable &&
                                    <ConfirmButton
                                        className={'btn btn-danger mr-auto'}
                                        onClick={this.remove}
                                        disabled={!this.props.isRemovable}>
                                        <Icon value={'trash'} className={'mr-1'} />
                                        <FormattedMessage
                                            id="customer.cards_on_file.delete_btn"
                                            defaultMessage="Remove"
                                        />
                                    </ConfirmButton>
                                }

                                <button type="button" className="btn btn-secondary" onClick={this.onCloseModal}>
                                    <Icon value={'times'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="common.send_email.modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <button onClick={this.save} className="btn btn-primary"
                                    disabled={this.state.name.length === 0}>
                                    <FormattedMessage
                                        id="common.modify_group.modal.save_btn"
                                        defaultMessage="Save"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        )
    }

}

const mapState = (state, props) => {
    return {
        ...props,
    }
}
const mapDispatch = { patchPricingTableGroup, deletePricingTableGroup }
const connector = connect(mapState, mapDispatch)
export default connector(injectIntl(QuoteGroupNameModal));





// WEBPACK FOOTER //
// ./src/common/quote/groupnamemodal.component.jsx